"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CopyObjectInput_1 = require("./CopyObjectInput");
var CopyObjectOutput_1 = require("./CopyObjectOutput");
var ObjectNotInActiveTierError_1 = require("./ObjectNotInActiveTierError");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.CopyObject = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "CopyObject",
    http: {
        method: "PUT",
        requestUri: "/{Bucket}/{Key+}"
    },
    input: {
        shape: CopyObjectInput_1.CopyObjectInput
    },
    output: {
        shape: CopyObjectOutput_1.CopyObjectOutput
    },
    errors: [
        {
            shape: ObjectNotInActiveTierError_1.ObjectNotInActiveTierError
        }
    ]
};
//# sourceMappingURL=CopyObject.js.map